/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { ReactivateRequestBillingCadence } from './reactivateRequestBillingCadence';
import type { ReactivateRequestPlanSlug } from './reactivateRequestPlanSlug';

export interface ReactivateRequest {
  plan_slug: ReactivateRequestPlanSlug;
  billing_cadence: ReactivateRequestBillingCadence;
  /**
     * @minimum 1
     * @maximum 10
     */
  seat_count: number;
  user_ids_to_activate?: string[];
}
